import 'jquery-is-in-viewport';

export function iframeLazyload ($elements) {
	$elements.each((i, el) => {
		const $el = $(el);

		$el.isInViewport(function (status) {
			if (status === 'entered') {
				$(this).prop('src', $el.data('src'));
			}
		});
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/iframe-lazyload.js